import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/components/SEO";
import { fetchPageBySlug } from "@/lib/wp";

export default function WPPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let live = true;
    setStatus("loading");
    fetchPageBySlug(slug)
      .then((p) => {
        if (!live) return;
        setPage(p);
        setStatus(p ? "ready" : "missing");
      })
      .catch(() => {
        if (!live) return;
        setStatus("missing");
      });
    return () => {
      live = false;
    };
  }, [slug]);

  useSEO({
    title: page ? `${page.title} | Loan Salaah` : "Page | Loan Salaah",
    description: page?.excerpt || "",
  });

  if (status === "loading") {
    return (
      <div className="mx-auto max-w-3xl animate-pulse px-4 pb-24 pt-40" data-testid="wp-page-loading">
        <div className="h-12 w-2/3 rounded bg-sand" />
        <div className="mt-8 space-y-3">
          <div className="h-4 w-full rounded bg-sand" />
          <div className="h-4 w-5/6 rounded bg-sand" />
          <div className="h-4 w-4/6 rounded bg-sand" />
        </div>
      </div>
    );
  }

  if (status === "missing") {
    return (
      <div className="mx-auto max-w-3xl px-4 py-40 text-center" data-testid="wp-page-not-found">
        <h1 className="font-serif text-4xl font-semibold text-concordia">Page not found.</h1>
        <p className="mt-3 text-sm text-slate">It may have been unpublished or the link has changed.</p>
        <Link to="/" className="mt-6 inline-block rounded-full bg-concordia px-7 py-3 text-sm font-semibold text-ivory">Back to home</Link>
      </div>
    );
  }

  return (
    <div data-testid={`wp-page-${page.slug}`} className="pb-24 pt-36">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h1 className="font-serif text-4xl font-semibold tracking-tight text-concordia sm:text-5xl">{page.title}</h1>
          {page.image && (
            <img src={page.image} alt={page.title} className="mt-8 aspect-[16/8] w-full rounded-3xl border border-sand object-cover" />
          )}
          <div className="blog-content mt-10" dangerouslySetInnerHTML={{ __html: page.content }} />
        </Reveal>
      </div>
    </div>
  );
}
